import { render, staticRenderFns } from "./incidentsInspector.vue?vue&type=template&id=9eb7de4e&"
import script from "./incidentsInspector.vue?vue&type=script&lang=js&"
export * from "./incidentsInspector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports